import { render, staticRenderFns } from "./GCheckbox.vue?vue&type=template&id=66715e71&scoped=true&"
import script from "./GCheckbox.vue?vue&type=script&lang=ts&"
export * from "./GCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckbox.vue?vue&type=style&index=0&id=66715e71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66715e71",
  null
  
)

export default component.exports